import { timeZonesList } from './timeZones';

export const ISO_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS";

export const IANAToWindows = (ianaTimezone: string) =>
  timeZonesList.timeZones.find((timezone) => timezone.ianaTimeZoneId === ianaTimezone)?.windowsTimeZoneId;
